"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MobilePageFrameNav = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Shell_1 = require("../Shell");
const web_blizzard_reporting_1 = require("@snapchat/web-blizzard-reporting");
const web_experiments_1 = require("@snapchat/web-experiments");
const Navigation_1 = require("../Navigation");
/**
 * Old mobile Page Frame nav
 */
function OldMobilePageFrameNav(props) {
    const { navigationProps, ...rest } = props;
    return ((0, jsx_runtime_1.jsx)(Navigation_1.MobileNavigation, { ...navigationProps, ...rest, hasLegacyOISCTA: props.navigationProps.hasLegacyOISCTA ?? true }));
}
/**
 * Old mobile Page Frame nav
 */
function NewMobilePageFrameNav(props) {
    const { navigationProps, ...rest } = props;
    return (0, jsx_runtime_1.jsx)(Navigation_1.MobileNavigation, { ...navigationProps, ...rest, hasLegacyOISCTA: false });
}
/**
 * Experiment Wrapper for the new OIS experiment
 */
function NewOISExperimentMobilePageFrameNav(props) {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const newOISExperimentProps = props.newOISExperimentProps;
    const configId = newOISExperimentProps.configID;
    return ((0, jsx_runtime_1.jsx)(Shell_1.webConfigContext.Experiment, { configId: configId, webClientId: props.webClientId ?? "", pageTypeName: web_blizzard_reporting_1.PageType[props.pageType], onLogExposure: props.newOISExperimentProps?.onNewOISExperimentExposureLog, children: ({ treatmentValue, isLoading, userHasOptedOutOfExperiments }) => {
            if (isLoading ||
                treatmentValue === web_experiments_1.TreatmentValue.Control ||
                userHasOptedOutOfExperiments) {
                return (0, jsx_runtime_1.jsx)(OldMobilePageFrameNav, { ...props });
            }
            return (0, jsx_runtime_1.jsx)(NewMobilePageFrameNav, { ...props });
        } }));
}
/**
 * The mobile version of the nav part of the page frame
 */
function MobilePageFrameNav(props) {
    const NavComponent = props.newOISExperimentProps?.enableNewOISExperiment
        ? NewOISExperimentMobilePageFrameNav
        : OldMobilePageFrameNav;
    return (0, jsx_runtime_1.jsx)(NavComponent, { ...props });
}
exports.MobilePageFrameNav = MobilePageFrameNav;
//# sourceMappingURL=MobilePageFrameNav.js.map